var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root some-error"},[_c('transition',{attrs:{"name":"scale","appear":""}},[_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.errorCircle)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }